// declare module "*.json"
// { const value: any;
//   export default value;
// }

import { Component, Prop, Vue, Ref, Watch } from 'vue-property-decorator';
import SummaryView from '../summary-view/index.vue';
import StrategyView from '../strategy-view/index.vue';
import { Strategy } from '@/classes/Strategy';
import { StrategyStats } from '@/classes/StrategyStats';
import { StrategyMeta } from '@/classes/StrategyMeta';
import { StrategiesData } from '@/classes/StrategiesData';
import AWS, { S3 } from 'aws-sdk';
import { Auth } from 'aws-amplify';
import s3 from 'aws-sdk/clients/s3';
import axios from 'axios';
// import s3 = require('aws-sdk/clients/s3');
// AWS.config.update({region: 'us-west-2'});



@Component({
  name: 'content-view',
  components: {
    SummaryView,
    StrategyView,
  },
})
export default class ContentView extends Vue {
  public viewingStrategy: boolean = false;
  public selectedStrategy: Strategy|null = null;
  public type: string = 'backtest';
  // public strategies: Strategy[] = [
  //   new Strategy('Strategy 1',
  //     '1m',
  //     new StrategyMeta('Strategy 3', ['BTC', 'ETH'], '1m'),
  //     [5.0,6.0,7.0,8.0,7.0,7.0,6.0,5.0,4.0,7.0,9.0,12.0,12.0,13.0,11.0,11.0,10.0,8.0,10.0,7.0,11.0],
  //     new StrategyStats(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1)
  //   ),
  //   new Strategy('Strategy 2',
  //     '1m',
  //     new StrategyMeta('Strategy 3', ['BTC', 'ETH'], '1m'),
  //     [5.0,6.0,7.0,8.0,7.0,7.0,6.0,5.0,4.0,7.0,9.0,12.0,12.0,13.0,11.0,11.0,10.0,8.0,10.0,7.0,11.0],
  //     new StrategyStats(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1)
  //   ),
  //   new Strategy('Strategy 3',
  //     '1m',
  //     new StrategyMeta('Strategy 3', ['BTC', 'ETH'], '1m'),
  //     [5.0,6.0,7.0,8.0,7.0,7.0,6.0,5.0,4.0,7.0,9.0,12.0,12.0,13.0,11.0,11.0,10.0,8.0,10.0,7.0,11.0],
  //     new StrategyStats(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1)
  //   ),
  // ];

  public url: string = 'http://54.156.113.23:5000' //TODO move to some config file, etc.
  public s3: s3|undefined = undefined;
  public bucket = 'trading-bucket-crypto';
  public aws_region = 'us-east-1';
  public loggedin: boolean = false;
  public strategies: Strategy[] = [];
  public db: boolean = true;
  public sortStat: string = 'Annualized Returns';


  @Watch('type')
  onTypeChange(oldVal: string, newVal: string) {
    this.getAllStrategies()
  }



  onStrategySelected(strategy: Strategy) {
    this.selectedStrategy = strategy;
    this.viewingStrategy = true;
  }

  onStrategyClose() {
    this.viewingStrategy = false;
    this.selectedStrategy = null;
  }

  created() {
    this.login();
  }

  login() {
    Auth.currentCredentials()
  .then(credentials => {
    this.s3 = new S3({
      apiVersion: '2006-03-01',
      credentials: Auth.essentialCredentials(credentials)
    });
    this.getAllStrategies();

  })
  }

  getAllStrategies() {

    const bucketParams = {
      Bucket : this.bucket,
      Prefix: 'strategies/',
      Delimiter: '/',
    };
    const self = this;


    this.strategies = [];

    const path = '/results'

    if (this.db) {
      // Call to DB to get all strategies
      axios.request<Strategy[]>({
        url: this.url+path,
        params: {
          type: this.type
        }
          }).then((response) => {
            // `response` is of type `AxiosResponse<ServerData>`
            console.log(response);
            this.strategies = response.data.map((x) => {
              let strat = new Strategy(x.name, x.interval, x.meta);
              if ('backtest' in x) {
                strat.backtest = x.backtest;
              }
              if ('paper' in x) {
                strat.paper = x.paper;
              }
              if ('live' in x) {
                strat.live = x.live;
              }
              return strat;

            });
            // `data` is of type ServerData, correctly inferred
      });
    }
    else {
      // Call S3 to obtain a list of the objects in the bucket
      this.s3!.listObjectsV2(bucketParams, function(err, data) {
        if (err) {
          // console.log("Error", err);
        } else {
          // console.log("Success", data);
          for (const strat of data.CommonPrefixes!) {
            const bucketParams2 = {
              Bucket : self.bucket,
              Prefix: strat.Prefix,
              Delimiter: '/',
            };
            let self2 = self;
            self.s3!.listObjectsV2(bucketParams2, function(err2, data2) {
              if (err) {
                // console.log("Error", err2);
              } else {
                // console.log("Success", data2);
                let newStrats = data2.CommonPrefixes!.map(function(path) {
                  let splits = path.Prefix!.split('/');
                  // console.log(splits);

                  let strat = new Strategy(splits[1], splits[2]);
                  let self3 = self2;
                  self2.getStrategy(strat, self2.type, () => {
                    let idx = self2.strategies.indexOf(strat);
                    self2.strategies.splice(idx, 1);
                  });
                  return strat;
                });
                self2.strategies = self2.strategies.concat(newStrats);

                // self2.strategies = strategies;
                // console.log(strategies);
              }
            });
          }
        }
      });
    }
  }

  getMostRecent(strat: Strategy, type: string, callback: (max: number) => void) {
    const listObjParams = {
      Bucket : this.bucket,
      Prefix: 'strategies/' + strat.name + '/' + strat.interval + '/' + type + '/',
      Delimiter: '/',
    };

    this.s3!.listObjectsV2(listObjParams, function(err, data) {
      if (err) {
        // console.log("Error", err);
      } else {
        // console.log("Success", data);

        let runs = data.CommonPrefixes!.map(function(path) {
          let splits = path.Prefix!.split('/');
          // console.log(splits);

          return parseInt(splits[4]);
        });


        let max = Math.max(...runs);
        // console.log(max);
        callback(max);

      }
    });
  }

  getStrategy(strat: Strategy, type: string, callback: () => void) {


    this.getMostRecent(strat, type, (max) => {
      if (max != Number.NEGATIVE_INFINITY){
        const getObjParams = {
          Bucket : this.bucket,
          Key: 'strategies/' + strat.name + '/' + strat.interval + '/' + type + '/' + max + '/meta.json',
        };
        const getHistParams = {
          Bucket : this.bucket,
          Key: 'strategies/' + strat.name + '/' + strat.interval + '/' + type + '/' + max + '/hist.json',
        };
        const getStatsParams = {
          Bucket : this.bucket,
          Key: 'strategies/' + strat.name + '/' + strat.interval + '/' + type + '/' + max + '/stats.json',
        };

        this.s3!.getObject(getObjParams, function(err, data) {
          if (err) {
            // console.log("Error", err);
          } else {
            // console.log("Success", data);
            let meta: StrategyMeta = JSON.parse(data.Body!.toString());
            // console.log(meta);
            strat.meta = meta;
          }
        });
        this.s3!.getObject(getHistParams, function(err, data) {
          if (err) {
            // console.log("Error", err);
          } else {
            // console.log("Success", data);
            let hist: number[] = JSON.parse(data.Body!.toString());
            // console.log(hist);
            strat.getTypeResults(type)[0].history = hist;
          }
        });
        this.s3!.getObject(getStatsParams, function(err, data) {
          if (err) {
            // console.log("Error", err);
          } else {
            // console.log("Success", data);
            let stats: StrategyStats = JSON.parse(data.Body!.toString());
            // console.log(stats);
            strat.getTypeResults(type)[0].stats = stats;
          }
        });
      }
      else {
        callback();
      }


    });

  }

  switchType(type: string) {
    this.type = type;
    this.viewingStrategy = false;
    this.selectedStrategy = null;
  }

  get sortedStrategies() {
    let self = this;
    let sorted = this.strategies.sort((first, second) => {
      let stats1 = first.getTypeResults(this.type)[0].stats;
      let stats2 = second.getTypeResults(this.type)[0].stats;
      if (stats1 == undefined) {
        return 1;
      }
      if (stats2 == undefined) {
        return -1;
      }
      else {
        return self.getStat(self.sortStat, stats2!) - self.getStat(self.sortStat, stats1!);
      }
    });

    return sorted
  }

  getStat(stat:string, stats:StrategyStats) {
    if (stat === 'Annualized Returns') {
      return stats['Annualized Returns'];
    }
    if (stat === 'Annualized Sharpe') {
      return stats['Annualized Sharpe'];
    }
    return 0;
  }

  sortReturns() {
    this.sortStat = 'Annualized Returns';
  }

  sortSharpe() {
    this.sortStat = 'Annualized Sharpe';
  }

  toggleDataSource() {
    this.db = !this.db;
    this.getAllStrategies();
  }

}
